export const Spacer = ({ x = 0, y = 0, flex = 0 }) => {
  return (
    <div
      style={{
        height: y,
        width: flex ? 1 : x,
        flexGrow: flex,
      }}
    />
  );
}
